import { DarkButton, MainCol, MainContainer, MainRow } from "components/common";
import NavbarComp from "../navbar";
import { MainSection, Title, GetStartBtn, ImageContainer } from "./elements";
import herogif from "../../../assets/images/herogif.gif";
import { Image } from "react-bootstrap";

const HeroComp = () => {
  return (
    <div id="home">
      <NavbarComp />

      <MainSection>
        <MainContainer>
          <MainRow>
            <MainCol lg={6}>
              <Title className="animate__animated animate__fadeInLeft">
                <span>enterapp </span> Unlock
                <br /> the Future of
                <br /> Lorem Ipsum
              </Title>
              <div className="btn-div animate__animated animate__fadeInLeft">
                <DarkButton btnText="Get Started" />
              </div>
            </MainCol>

            <MainCol lg={6}>
              <ImageContainer className="animate__animated animate__fadeInRight">
                <Image src={herogif} alt="hero-image" fluid />
              </ImageContainer>
            </MainCol>
          </MainRow>
        </MainContainer>
      </MainSection>
    </div>
  );
};

export default HeroComp;
